import styled from 'styled-components';

export const PortfolioLeftContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  min-width: calc(100% - 240px);
  .container-fluid {
    margin-bottom: 0;
  }
  max-width: 100%;
`;
